import React from "react";
import Box from "@mui/material/Box";
import DetallePedido from "../../referencias-tablas/pedidos/DetallePedido";

// Panel expandido: tarjetas y cobros de la V1 (DetallePedido, sin cambios).
function DetallePedidoV2({ pedido }) {
  return (
    <Box sx={{ px: 1 }}>
      <DetallePedido datos={pedido} />
    </Box>
  );
}

export default DetallePedidoV2;
